// react
import React, { useState, useEffect, useRef } from 'react';

import { Box, Table, TableRow, TableBody, TableCell, Grid } from '@mui/material';
// openlayers
import { Style, Circle, Stroke, Fill, Text } from 'ol/style'
import Map from 'ol/Map'
import View from 'ol/View'
import Overlay from 'ol/Overlay'
import Feature from 'ol/Feature'
import TopoJSON from 'ol/format/TopoJSON';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Point, LineString, CircleGeom } from 'ol/geom'
import OSM from 'ol/source/OSM'
import { transform, fromLonLat } from 'ol/proj'
import { toStringXY } from 'ol/coordinate';
import { getRequest } from 'utils/apiRequest';
import { useGeographic } from 'ol/proj';

import '../assets/third-party/open-layers-controls.css';

// useGeographic();

function MapRoute(props) {
    const {from, to} = props;

  // set intial state
  const [map, setMap] = useState()
  const [featuresLayer, setFeaturesLayer] = useState()
  const [getInfo, setGeoInfo] = useState({ })
  const [locations, setLocations] = useState([]);
  // pull refs
  const mapElement = useRef()

  // create state ref that can be accessed in OpenLayers onclick callback function
  //  https://stackoverflow.com/a/60643670
  const mapRef = useRef()
  mapRef.current = map;

  const centerLatLng = [-98.5795, 39.8283];

  // initialize map on first render - logic formerly put into componentDidMount
  useEffect(() => {

    const initMap = new Map({
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        // initalFeaturesLayer,
      ],
      target: mapElement.current,
      view: new View({
        center: transform(centerLatLng, 'EPSG:4326', 'EPSG:3857'),
        zoom: 4,
      }),
    });

    var coords = [
        [from.longitude, from.latitude],
        [to.longitude, to.latitude],
      ];

      // ----- The line
      var lineString = new LineString(coords);
      // transform to EPSG:3857
      lineString.transform('EPSG:4326', 'EPSG:3857');
      
      // create the feature
      var feature = new Feature({
        geometry: lineString,
        name: 'Line'
      });
      
      var lineStyle = new Style({
        stroke: new Stroke({
            color: '#0000FF',
            width: 1,
            lineDash: [5, 2],
            lineCap: 'butt'
        })
      });
      // --- End The Line
      
      var source = new VectorSource({
        features: [feature]
      });
      var vector = new VectorLayer({
        source: source,
        style: [lineStyle]
      });
      initMap.addLayer(vector);



    setMap(initMap)
  }, [])


const hasInfo = getInfo && getInfo.info && getInfo.info.zip_code !== undefined;

  // render component
  return (<Grid container spacing={3}>
    <Grid item xs={12} md={!hasInfo ? 12 : 8} lg={!hasInfo ? 12 : 9.5}>
      <Box ref={mapElement} className="map-container" style={{
        height: '400px',
        width: '100%',
        marginBottom: '10px'
      }}>
      </Box>
    </Grid>
  </Grid>
  )

}

export default MapRoute;